/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UpdateProfileRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/profile_messages.pb'
import {UpdateProfileResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/profile_messages.pb'


export const updateProfile = (request: UpdateProfileRequest, options?: CashRequestOptions) => post<UpdateProfileRequest, UpdateProfileResponse>("/2.0/cash/update-profile", request, {...options, rejectOnError: true })